/* Window event dispatched after custom fields are saved, used to refresh the usage counter */
export const CUSTOM_FIELDS_SAVED_EVENT = 'custom_fields_saved';

/* Linked object types which count towards the custom field limit, mirrors the backend list */
export const CUSTOM_FIELD_LIMIT_OBJECT_TYPES: string[] = [
    'job_workflow',
    'job_workflow_appointment',
    'contact_entity_type',
    'deal_pipeline',
    'product_category',
];

/* Custom field group types */
export type LinkedCustomFieldGroupObjectType =
    | 'product_category'
    | 'asset_type'
    | 'asset_type_inspection'
    | 'form'
    | 'form_template'
    | 'job_workflow_appointment';

export interface CustomFieldGroupType {
    id?: number;
    uuid?: string;
    linked_object_type: LinkedCustomFieldGroupObjectType;
    linked_object_value?: string | null;
    title: string;
    description?: string | null;
    ordering: number;
    pdf_width?: 'full_width' | 'half_width';
    deleted?: boolean;
};

export interface CustomFieldGroupSectionType {
    id: number;
    title?: string | null;
    description?: string | null;
    ordering: number;
    fields: CustomFieldEntryType[];
}

/* Custom field types */
export type LinkedCustomFieldSetObjectType =
    | 'job_workflow'
    // | 'job_workflow_appointment'  // Implement in a later stage
    | 'contact_entity_type'
    | 'deal_pipeline'
    // | 'product_category'  // Implement in a later stage
    | 'asset_type'
    | 'asset_type_inspection';

export type LinkedCustomFormObjectType =
    | 'form'
    | 'form_template';

export type LinkedCustomFieldObjectType = LinkedCustomFieldSetObjectType | LinkedCustomFormObjectType;

export type CustomFieldFieldType =
    | 'input'
    | 'textarea'
    | 'dropdown'
    | 'checkbox'
    | 'boolean'
    | 'yes_no'
    | 'acceptable'
    | 'compliant'
    | 'tabs'
    | 'amount'
    | 'number'
    | 'date'
    | 'time'
    | 'photo'
    | 'signature';

export interface CustomFieldOptionType {
    id?: number;
    uuid?: string;
    field_id?: number | string;
    label: string;
    value: string;
    color?: string | null; // Background class of the option color, empty for no color
    ordering: number;
    deleted?: boolean;
};

export interface CustomFieldType {
    id?: number;
    uuid?: string;
    linked_object_type: LinkedCustomFieldObjectType;
    linked_object_value?: string | null;
    group_id?: number | string | null;
    parent_field_id?: number | string | null;
    show_when_option_id?: number | string | null;
    show_when_boolean?: boolean | null;
    label: string;
    placeholder?: string | null;
    description?: string | null;
    field_type: CustomFieldFieldType;
    options?: CustomFieldOptionType[];
    required: boolean;
    shared_key?: string | null;
    hide_externally: boolean;
    ordering: number;
    deleted?: boolean;    
};


/* Custom field entru types */
export interface CustomFieldEntryType {
    group_id?: number | null;
    group_title?: string | null;
    group_description?: string | null;
    group_ordering?: number | null;
    id: number;
    field_id: number;
    label: string;
    field_type: CustomFieldFieldType;
    placeholder?: string | null;
    description?: string | null;
    required: boolean;
    hide_externally: boolean;
    ordering: number;
    options?: CustomFieldOptionType[];
    value: any;
    parent_field_id?: number | null;
    show_when_option_id?: number | null;
    show_when_option_label?: string | null;
    show_when_boolean?: boolean | null;
};


/* Custom field answer types */
export type LinkedCustomFieldAnswerObjectType =
    | 'job'
    | 'product'
    | 'contact'
    | 'deal'
    | 'asset'
    | 'form_sheet';

export interface CustomFieldAnswerType {
    id?: number;
    uuid?: string;
    field_id: number | string;
    linked_object_type: LinkedCustomFieldAnswerObjectType;
    linked_object_id: number;
    value_text?: string | null;
    value_number?: number | null;
    value_boolean?: boolean | null;
    value_date?: string | null;
    value_datetime?: string | null;
    description_value?: string | null;
    created_by_user_id?: number | null;
    modified_by_user_id?: number | null;
    deleted?: boolean;
};


/* Form types */
export interface FormType {
    id?: number;
    uuid?: string;
    name: string;
    description?: string | null;
    deleted?: boolean;
    division?: number | null;
    groups?: CustomFieldGroupType[];
    fields?: CustomFieldType[];
};

export interface FormTemplateType {
    id?: number;
    uuid?: string;
    name: string;
    description?: string | null;
    deleted?: boolean;
    division?: number | null;
    groups?: CustomFieldGroupType[];
    fields?: CustomFieldType[];
};

export type FormBuilderObjectType = FormType | FormTemplateType;

export type FormSheetStatusType = 'draft' | 'completed';

export interface FormSheetType {
    id?: number;
    uuid?: string;
    form_id: number | string;
    job_id: number;
    include_asset_inspection?: boolean;
    status: FormSheetStatusType;
    completed_at?: string | null;
    created_by_user_id?: number | null;
    completed_by_user_id?: number | null;
    deleted?: boolean;
};

export interface CustomFieldPhotoValueType {
    id: number
    file: string
    thumbnail?: string | null
    filename: string
    mime_type?: string | null
    extension?: string | null
    width?: number | null
    height?: number | null
    orientation?: string | null
    description?: string | null
    added_at?: string | null
    created?: string
    modified?: string
}

export interface CustomFieldSignatureValueType {
    id: number
    file: string
    filename: string
    created?: string
    modified?: string
}